import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BillingAPI } from "@/lib/api";

const inr = (paise) => `₹${(paise / 100).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

/** Wallet + transaction history card for external (paying) users. */
export default function WalletCard() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await BillingAPI.wallet();
        setData(r.data);
      } catch (e) {
        setErr(e?.response?.data?.detail || "Could not load wallet");
      }
    })();
  }, []);

  return (
    <div className="v-surface" style={{ padding: 28 }} data-testid="wallet-card">
      <div className="overline" style={{ color: "var(--v-accent)" }}>Audit credits</div>
      <h3 style={{ marginTop: 8, fontSize: 24 }}>Your wallet</h3>
      {err && <p style={{ color: "#ef4444", fontSize: 13, marginTop: 8 }}>{err}</p>}

      {data && (
        <>
          <div style={{ display: "flex", alignItems: "baseline", gap: 12, marginTop: 18 }}>
            <div style={{ fontSize: 44, fontWeight: 300, letterSpacing: "-.02em" }} data-testid="wallet-balance">
              {data.wallet.audit_credits}
            </div>
            <div style={{ fontSize: 13, color: "var(--v-text-2)" }}>
              audit credit{data.wallet.audit_credits === 1 ? "" : "s"} left
            </div>
          </div>
          <div style={{ marginTop: 6, fontSize: 12, color: "var(--v-text-2)" }}>
            Lifetime purchased: <b style={{ color: "var(--v-text)" }}>{data.wallet.lifetime_credits_purchased}</b>
            {" · "} Lifetime spend: <b style={{ color: "var(--v-text)" }}>{inr(data.wallet.lifetime_spend_inr_paise || 0)}</b>
          </div>

          <div style={{ marginTop: 22, display: "flex", gap: 12, flexWrap: "wrap" }}>
            <Link to="/pricing" className="v-btn" style={{ background: "var(--v-accent)", color: "#0A0A0A" }} data-testid="wallet-buy-credits-btn">
              Buy more credits →
            </Link>
            <a href="mailto:support@thereforedesign.co.in?subject=Verdict — GST invoice request" className="v-btn v-btn-ghost" style={{ padding: "8px 14px", fontSize: 11 }}>
              Request GST invoice
            </a>
          </div>

          {data.transactions && data.transactions.length > 0 && (
            <div style={{ marginTop: 28 }}>
              <div className="overline" style={{ fontSize: 10, color: "var(--v-text-2)" }}>Recent activity</div>
              <div style={{ marginTop: 10, borderTop: "1px solid var(--v-border)" }}>
                {data.transactions.slice(0, 6).map((t) => (
                  <div
                    key={t.transaction_id}
                    data-testid={`txn-${t.transaction_id}`}
                    style={{
                      display: "flex", justifyContent: "space-between", alignItems: "center",
                      padding: "10px 0", borderBottom: "1px solid var(--v-border)",
                      fontSize: 12,
                    }}
                  >
                    <div style={{ minWidth: 0 }}>
                      <div style={{ color: "var(--v-text)" }}>{t.note || t.kind}</div>
                      <div className="mono" style={{ color: "var(--v-text-2)", marginTop: 2, fontSize: 10 }}>
                        {new Date(t.created_at).toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}
                        {t.amount_paise > 0 && <> · {inr(t.amount_paise)}</>}
                      </div>
                    </div>
                    <div style={{
                      fontWeight: 700, fontSize: 13,
                      color: t.credits_delta > 0 ? "#06B6D4" : "#ef4444",
                    }}>
                      {t.credits_delta > 0 ? "+" : ""}{t.credits_delta}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
